import script from "./NoRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./NoRecord.vue?vue&type=script&lang=ts&setup=true"

import "./NoRecord.vue?vue&type=style&index=0&id=2a36139e&lang=scss"

const __exports__ = script;

export default __exports__